import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import {
  PaymentApi,
  RequestStrategyEnum,
  type GetDepositPaymentsByRecipientIdRequest,
  type PaymentsByRecipientIdResponse,
  type WithSignal,
} from '@shared/api';

const getPaymentsByRecipientIdEffect = createEffect(({ signal, ...request }: WithSignal<GetDepositPaymentsByRecipientIdRequest>) =>
  PaymentApi.getPaymentsByRecipientId(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ data: PaymentsByRecipientIdResponse[]; total: number }>({ data: [], total: 0 })
  .on(getPaymentsByRecipientIdEffect.done, (_, data) =>
    data.result ? { total: data.result.data?.total ?? 0, data: data.result.data?.data || [] } : { total: 0, data: [] },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getPaymentsByRecipientIdEffect.pending, (_, data) => data)
  .on(getPaymentsByRecipientIdEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getPaymentsByRecipientIdEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getPaymentsByRecipientIdEffect, () => null)
  // .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getPaymentsByRecipientIdEffect.fail, () => 'Something went wrong while fetching Transactions. Please try again.')
  .on(getPaymentsByRecipientIdEffect.done, () => null)
  .reset(clearEvent);

const getPaymentsByRecipientIdApi = ApiUtils.wrapperApi(getPaymentsByRecipientIdEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getPaymentsByRecipientIdApi.cancel());

export const $paymentsByRecipientId = {
  events: {
    getPaymentsByRecipientId: getPaymentsByRecipientIdApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
